import axios from "@/libs/api.request";
// 获取列表
export const getB2bBill = (params) => {
  return axios.request({
    url: "/finance/AirExtractBill",
    method: "get",
    params,
  });
};

export const getDetails = (params) => {
  return axios.request({
    url: `/finance/AirExtractBill/${params.id}`,
    method: "get",
    params,
  });
};

export const exportB2bBill = (id) => {
  return axios.request({
    url: `/finance/dbl/bill/export/${id}`,
    method: "get",
  });
};

// 账单导出
export const exportDetailBill = (id) => {
  return axios.request({
    url: "/finance/AirExtractBill/export/" + id,
    method: "post",
  });
};

export const addB2bBill = (data) => {
  return axios.request({
    url: `/finance/dbl/bill`,
    method: "post",
    data,
  });
};

export const getB2bBillUSer = () => {
  return axios.request({
    url: `/finance/dbl/bill/canCheckoutUser`,
    method: "get",
  });
};

export const updateB2bBill = (data) => {
  return axios.request({
    url: `/finance/AirExtractBill/${data.id}`,
    method: "put",
    data,
  });
};

export const getB2bCountryCurrency = (id) => {
  return axios.request({
    url: `/finance/dbl/bill/totalAllFromCurrency/${id}`,
    method: "get",
  });
};

export const ConfirmB2bBill = (data) => {
  return axios.request({
    url: `/finance/dbl/bill/pushToClient`,
    method: "post",
    data,
  });
};

export const b2bReStatistics = (data) => {
  return axios.request({
    url: `/finance/dbl/bill/totalBillAmount/${data.id}`,
    method: "post",
    data,
  });
};

export const b2bWriteOff = (data) => {
  return axios.request({
    url: `/finance/AirExtractBill/writeOff/${data.id}`,
    method: "post",
    data,
  });
};

export const getConfig = () => {
  return axios.request({
    url: `/finance/dbl/bill/config`,
    method: "get",
  });
};

export const removeDetail = (id, data) => {
  return axios.request({
    url: `/finance/dbl/bill/removeDetail/${id}`,
    method: "post",
    data,
  });
};

export const delDouBill = (id) => {
  return axios.request({
    url: `/finance/AirExtractBill/${id}`,
    method: "delete",
  });
};

export const getB2bBillDetails = (params) => {
  return axios.request({
    url: `/finance/dbl/bill/getWriteOff/${params.id}`,
    method: "get",
  });
};

export const getB2bContractHeader = (params) => {
  return axios.request({
    url: `/common/dblContractHeader`,
    method: "get",
    params,
  });
};

export const againBillAmount = (data) => {
  return axios.request({
    url: `/finance/AirExtractBill/rate/${data.id}`,
    method: "post",
    data,
  });
};

export const postConfirm = (id) => {
  return axios.request({
    url: `/finance/AirExtractBill/confirm/` + id,
    method: "post",
  });
};

export const removeDetail1 = (data) => {
  return axios.request({
    url: `/finance/AirExtractBill/removeDetail/${data.id}`,
    method: "post",
    data,
  });
};

export const append = (data) => {
  return axios.request({
    url: `/finance/AirExtractBill/append/${data.id}`,
    method: "post",
    data,
  });
};

export const recalculate = (data) => {
  return axios.request({
    url: `/finance/AirExtractBill/recalculate`,
    method: "post",
    data,
  });
};


export const getWaitWriteOff = (id) => {
  return axios.request({
    url: `/finance/AirExtractBill/getWaitWriteOff/`+id,
    method: "get",
  });
};
export const getWriteOffRecord = (id) => {
  return axios.request({
    url: `/finance/AirExtractBill/getWriteOffRecord/`+id,
    method: "get",
  });
};


export const cancelConfirm = (data) => {
  return axios.request({
    url: `/finance/AirExtractBill/cancelConfirm`,
    method: "post",
    data,
  });
};
